import { useEffect } from "react";

// Simple form persistence hook for backward compatibility
export function useFormPersistence(activeSection: string) {
  useEffect(() => {
    // Store the active section in session storage for persistence
    sessionStorage.setItem("dashboard_active_section", activeSection);
  }, [activeSection]);

  // Get the persisted section on mount
  const getPersistedSection = () => {
    return sessionStorage.getItem("dashboard_active_section") || "profile";
  };

  const clearPersistence = () => {
    sessionStorage.removeItem("dashboard_active_section");
  };

  return {
    getPersistedSection,
    clearPersistence,
  };
}
